import type { PatchRelease } from "../types";

export const release: PatchRelease = {
  id: "2026-06-27_01",
  version: "2026.06.27",
  date: "27 Jun 2026",
  sinceCommit: "f7f9acc",
  gameplay: [
    {
      text: "**Skill Draft**: synergy skills can now appear in any between-round draft instead of only on rounds 3 and 6 — roughly a quarter of passive options now roll from the synergy pool.",
    },
    {
      text: "When two opposing projectiles collide head-on, the **clash shockwave** is now tighter (knockback radius **210 → 100**) and lands the instant the bolts meet, instead of arriving a beat late for distant players.",
    },
    {
      text: "You can now **spectate live matchmaking matches** straight from the main menu.",
    },
    {
      text: "**Achievements** that track skills tried, synergies, and matches completed now only progress in matchmaking (Quick Match, Find Match, and the PvE queue) — custom lobbies no longer count toward them.",
    },
  ],
  skills: [],
};
